<template>
    <div>

        <Modal v-model="show"
            title="预售 - 转运站发货"
            :width="1200"
            :footer-hide="true"
            @on-visible-change="onShowChange">
            <Spin v-if="innerSpin"
                size="large"
                fix></Spin>
            <Card :padding="0"
                :bordered="false"
                :dis-hover="true">
                <Row :gutter="16">
                    <Col span="24">
                    <Form ref="deliveryForm"
                        label-position="top">

                        <Row :gutter="16">
                            <Col span="4">
                            <FormItem label="定单编号">
                                <Input :value="orderRecord.preSaleOrderRecordCode"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="4">
                            <FormItem label="会员名称">
                                <Input :value="orderRecord.deliveryAddressContacts"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="4">
                            <FormItem label="会员电话">
                                <Input :value="orderRecord.deliveryAddressPhone"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="4">
                            <FormItem label="会员账户余额">
                                <Input :value="memberFundInfo.memberFundBalance"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="4">
                            <FormItem label="会员定金余额">
                                <Input :value="memberFundInfo.memberDepositBablance"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="4">
                            <FormItem label="定单日期">
                                <Input :value="formatDateTimeString(orderRecord.preSaleOrderRecordCreateAt)"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <!-- <Col span="2">
                        <FormItem label="定单状态">
                            <Input :value="orderRecord.orderStatus"
                                readonly></Input>
                        </FormItem>
                        </Col> -->
                        </Row>
                        <Row :gutter="16">
                            <Col span="4">
                            <FormItem label="收货区域">
                                <Input :value="orderRecord.dist"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="4">
                            <FormItem label="物流配置">
                                <Input :value="logisticsInfo.logisticsDistName"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="4">
                            <FormItem label="物流公司">
                                <Input :value="logisticsInfo.logisticsCompanyName"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="4">
                            <FormItem label="物流单价">
                                <Input :value="logisticsInfo.logisticsCompanyPrice"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="4">
                            <FormItem label="物流费用">
                                <div slot="label"> <span>物流费用</span>
                                    <a v-if="orderRecord.preSaleOrderRecordIsPaidDeliveryFee === 1"
                                        href="#"
                                        style="margin-left:10px;color:red;"
                                        @click="deliveryFeeHistoryModal.show = true;">查看运费</a>
                                    <!-- <Button type="warning"
                                        size="small"
                                        style="margin-left:10px;"
                                        @click="deliveryFeeHistoryModal.show = true;"></Button> -->
                                </div>
                                <Input-number v-model="orderRecord.preSaleOrderRecordStationDeliveryFee"
                                    style="width:100%;">
                                </Input-number>
                            </FormItem>
                            </Col>
                            <Col span="4">
                            <FormItem label=" ">
                                <Button type="primary"
                                    @click="OnPayDeliveryFee">收取物流费</Button>
                            </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="16">
                            <Col span="24">
                            <Table ref="productTable"
                                size='small'
                                :columns="productTable.columns"
                                :data="orderDetails"
                                highlight-row
                                stripe
                                border />
                            </Col>
                        </Row>

                        <Row v-if="orderRecord.preSaleOrderRecordIsPaidDeliveryFee === 1"
                            :gutter="16"
                            class="row-margin-top-15"
                            style="margin-top:10px;"
                            type="flex"
                            justify="space-between">

                            <Col span="10">
                            <DatePicker :value="form.deliveryDate"
                                type="date"
                                format="yyyy-MM-dd"
                                placeholder="请填写发货日期"
                                @on-change="onDeliveryDateChange" />
                            <Checkbox v-model="needPayBackDeposit"
                                style="margin-left:10px;">返还定金</Checkbox>
                            <Button type="primary"
                                @click="onSubmit">发货</Button>
                            <Button type="success"
                                style="margin-left:5px;"
                                @click="printDeliveryRecord()">打印送货单</Button>
                            </Col>
                            <Col span="10">
                            <div style="text-align:right;">
                                <span>苗场发货量:{{productTable.totalSeedfarmQuantity}}</span>
                                <span style="margin-left:20px;">转运站发货量:{{productTable.totalQuantity}}</span>
                                <span style="margin-left:20px;">转运站发货金额:{{numberToFixed(productTable.totalValue,2)}}</span>
                            </div>

                            </Col>
                        </Row>

                    </Form>
                    </Col>
                </Row>

                <Row :gutter="16"
                    class="row-margin-top-15"
                    style="margin-top:10px;">
                    <Col spal="24">
                    <Collapse :value="[]">
                        <Panel name="preSale">
                            历史发货单
                            <div slot="content">
                                <Table ref="deliveryHistoryTable"
                                    size="small"
                                    :columns="deliveryHistoryTable.columns"
                                    :data="deliveryDetails"
                                    stripe
                                    border />
                            </div>
                        </Panel>
                    </Collapse>
                    </Col>
                </Row>
            </Card>
        </Modal>

        <Modal v-model="deliveryFeeHistoryModal.show"
            title="该单运费收取记录">
            <List size="small">
                <ListItem v-for="(item, index) in deliveryFeeHistoryModal.deliveryFeeList"
                    :key="index">{{formatDateTimeString(item.memberFundRecordCreateAt)}} {{item.memberFundRecordOperatorName}} (￥:{{item.memberFundRecordConsume}}元)</ListItem>
            </List>

        </Modal>
    </div>
</template>

<script>
import { formatDateString, formatDateTimeString } from '@/libs/logic';
import DecimalInput from '@/components/number-input/decimal-input';
import CurrencyInput from '@/components/number-input/currency-input';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import { FILE_SERVER } from '@/api/modules/files';
import { numberToFixed } from '@/components/number-input/display-format';

import {
    getPreSaleDistributionStationDeliveryDetail,
    savePreSaleDistributionStationDelivery,
    savePreSaleDeliveryFee,
    printPreSaleDistributionStationDeliveryDetail
} from '@/api/modules/distributionStation-management/distributionStation-delivery';

export default {
    name: 'PreDistributionStationDeliveryEdit',
    components: {
        CurrencyInput
    },
    data() {
        return {
            show: false,
            recordUuid: '',
            deliveryUuid: '',
            seedFarmUuid: '',
            innerSpin: false,
            preSaleOrderRecordUuid: '',
            needPayBackDeposit: false,
            orderRecord: {
                preSaleOrderRecordUuid: '',
                preSaleOrderRecordCode: '',
                preSaleOrderRecordCreateAt: '',
                orderStatus: '',
                preSaleOrderRecordStationDeliveryFee: 0,
                preSaleOrderRecordIsPaidDeliveryFee: 0

            },
            memberFundInfo: {
                memberFundBalance: 0,
                memberDepositBablance: 0
            },
            logisticsInfo: {
                logisticsCompanyName: '',
                logisticsCompanyPrice: 0,
                logisticsCompanyUuid: '',
                logisticsDistName: ''
            },
            orderDetails: [],
            deliveryDetails: [],
            productStores: [],
            deliveryFeeHistoryModal: {
                show: false,
                deliveryFeeList: []
            },
            productTable: {
                columns: [
                    { title: '产品编码', key: 'preSaleOrderDetailProductCode', align: 'center' },
                    { title: '产品名称', key: 'preSaleOrderDetailProductName', align: 'center' },
                    { title: '单位', key: 'preSaleOrderDetailProductUnit', align: 'center' },
                    { title: '预售周期', key: 'preSaleOrderDetailWeekKnownText', align: 'center' },
                    // { title: '订购量', key: 'preSaleOrderDetailOrderQuantity', align: 'center' },
                    { title: '确认价格', key: 'deliveryDetailPrice', align: 'center' }, //确认价格为苗场发货的价格
                    // { title: '确认订购量', key: 'preSaleOrderDetailOrderQuantityActual', align: 'center' },
                    // { title: '确认金额', key: 'preSaleOrderDetailTotalMoneyActual', align: 'center' },
                    { title: '库存量', key: 'storeAmount', align: 'center' },
                    // { title: '客户累计收货量', key: 'preSaleOrderDetailCustomerReceiveQuantity', align: 'center' },
                    { title: '苗场本单发货量', key: 'seedFarmDeliveryCount', align: 'center' },
                    {
                        title: '发货量',
                        key: 'deliveryAmount',
                        align: 'center',
                        render: (h, params) => {
                            //支付确认数量为零时的发货
                            // if (params.row.preSaleOrderDetailCustomerReceiveQuantity === 0 && params.row.storeAmount > 0 || params.row.preSaleOrderDetailOrderQuantityActual === 0) {
                            if (params.row.seedFarmDeliveryCount > 0 && params.row.storeAmount - params.row.seedFarmDeliveryCount >= 0 || params.row.seedFarmDeliveryCount === 0) {
                                return h(DecimalInput, {
                                    props: {
                                        value: params.row.deliveryAmount,
                                        max: params.row.seedFarmDeliveryCount,
                                        precision: 0
                                    },
                                    on: {
                                        change: newVal => {
                                            this.orderDetails[params.index].deliveryAmount = newVal;
                                            this.calculateTotalDeliveryAmount();
                                        }
                                    }
                                });
                            }
                            else {
                                return h('div', [
                                    h('span', '-')
                                ]);
                            }
                        }
                    },
                    {
                        title: '备注', key: 'remark', width: 200, align: 'center',
                        render: (h, params) => {
                            return h('Input', {
                                props: {
                                    value: params.row.remark
                                },
                                on: {
                                    'on-change': newVal => {
                                        this.orderDetails[params.index].remark = newVal.target.value;
                                    }
                                }
                            });
                        }
                    }
                ],
                totalQuantity: 0,
                totalValue: 0,
                totalSeedfarmQuantity: 0
            },
            deliveryHistoryTable: {
                columns: [
                    { title: '发货单号', key: 'distributionStationDeliveryRecordCode', width: 200, align: 'center' },
                    { title: '产品编号', key: 'productCode', width: 80, align: 'center' },
                    { title: '产品名称', key: 'productName', width: 120, align: 'center' },
                    { title: '单位', key: 'unitName', width: 60, align: 'center' },
                    { title: '送货数量', key: 'distributionStationDeliveryQuantity', width: 80, align: 'center' },
                    { title: '收货数量', key: 'distributionStationDeliveryDetailComplainRecevieCount', width: 80, align: 'center' },
                    { title: '投诉数量', key: 'distributionStationDeliveryDetailComplainQualityCount', width: 80, align: 'center' },
                    { title: '投诉信息', key: 'distributionStationDeliveryDetailComplainInfo', align: 'center' },
                    { title: '制单人', key: 'ownerName', width: 80, align: 'center' },
                    { title: '制单时间', key: 'distributionStationDeliveryRecordCreateAt', width: 120, align: 'center', render: (h, parmas) => dateTimeRender(h, parmas.row.distributionStationDeliveryRecordCreateAt) }
                ]
            },
            form: {
                deliveryDate: ''
            }
        };
    },
    mounted() {

    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(recordUuid, deliveryUuid, seedFarmUuid) {
            this.recordUuid = recordUuid;
            this.deliveryUuid = deliveryUuid;
            this.seedFarmUuid = seedFarmUuid;
            this.show = true;
        },
        formatDateString,
        numberToFixed,
        formatDateTimeString,
        printDeliveryRecord() {
            this.innerSpin = true;
            printPreSaleDistributionStationDeliveryDetail(this.preSaleOrderRecordUuid).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    window.open(FILE_SERVER + res.data.url, "_blank");
                }
            }).catch(() => {
                this.innerSpin = false;
            });
        },
        calculateTotalDeliveryAmount() {
            this.productTable.totalQuantity = this.orderDetails.map(e => {
                return e.deliveryAmount;
            }).reduce((total, num) => {
                return total + num;
            });

            this.productTable.totalValue = this.orderDetails.map(e => {
                return e.deliveryAmount * e.deliveryDetailPrice;
            }).reduce((total, num) => {
                return total + num;
            });
        },
        calculateTotalSeedfarmDeliveryAmount() {
            this.productTable.totalSeedfarmQuantity = this.orderDetails.map(e => {
                return e.seedFarmDeliveryCount;
            }).reduce((total, num) => {
                return total + num;
            });
        },
        OnPayDeliveryFee() {
            if (this.orderRecord.preSaleOrderRecordStationDeliveryFee === null
                || this.orderRecord.preSaleOrderRecordStationDeliveryFee < 0) {
                this.$Modal.error({ title: '运费不能小于0元', content: '' });
                return;
            }
            this.$Modal.confirm({
                title: '确认收取运费: ' + this.orderRecord.preSaleOrderRecordStationDeliveryFee + ' 元？',
                onOk: () => {
                    let data = {
                        preSaleOrderRecordUuid: this.orderRecord.preSaleOrderRecordUuid,
                        deliveryFee: this.orderRecord.preSaleOrderRecordStationDeliveryFee
                    };
                    savePreSaleDeliveryFee(data).then(res => {
                        if (res.code === 0) {
                            this.init();
                            this.$Message.success('运费收取成功');
                        }
                    });
                }
            });
        },
        onDeliveryDateChange(date) {
            this.form.deliveryDate = date;
        },
        init() {
            if (this.recordUuid) {
                this.preSaleOrderRecordUuid = this.recordUuid;
                this.innerSpin = true;
                getPreSaleDistributionStationDeliveryDetail(this.preSaleOrderRecordUuid, this.deliveryUuid).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.orderRecord = Object.assign(this.orderRecord, res.data.orderRecord);
                        this.productStores = res.data.productStores;

                        this.memberFundInfo = res.data.memberFundInfo;

                        this.orderDetails = res.data.orderDetails.filter(e => {
                            return e.productRelateSeedFarmUuid === this.seedFarmUuid;
                        }).map(item => {
                            const productUuid = item.preSaleOrderDetailProductUuid;
                            const query = this.productStores.find(s => s.distributionStationProductStoreProductUuid === productUuid);
                            let storeAmount = 0;
                            let deliveryAmount = 0;
                            let remark = '';

                            if (query) {
                                storeAmount = query.distributionStationProductStoreAmount;
                                deliveryAmount = storeAmount >= item.seedFarmDeliveryCount ? item.seedFarmDeliveryCount : 0;
                            }

                            return Object.assign(item, { storeAmount, deliveryAmount, remark });
                        });
                        this.calculateTotalDeliveryAmount();
                        this.calculateTotalSeedfarmDeliveryAmount();

                        this.deliveryDetails = res.data.deliveryDetails;

                        this.deliveryFeeHistoryModal.deliveryFeeList = res.data.deliveryFeeHistory;

                        this.logisticsInfo = Object.assign(this.logisticsInfo, res.data.logisticsInfo);

                        if (this.logisticsInfo.logisticsCompanyUuid === '') {
                            this.$Modal.warning({
                                title: '警告',
                                content: `尚未配置到 【${this.orderRecord.dist}】 的物流信息，请先设置`
                            });
                        }
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            }

        },
        onSubmit() {
            if (this.logisticsInfo.logisticsCompanyUuid === '') {
                this.$Modal.warning({
                    title: '警告',
                    content: `尚未配置到 【${this.orderRecord.dist}】 的物流信息，请先设置`
                });
                return;
            }
            const submitData = {
                needPayBackDeposit: this.needPayBackDeposit,
                preSaleDeliveryRecordUuid: this.deliveryUuid,
                preSaleOrderRecordUuid: this.preSaleOrderRecordUuid,
                deliveryDate: this.form.deliveryDate,
                deliveryFee: this.orderRecord.preSaleOrderRecordStationDeliveryFee,
                deliveryItems: this.orderDetails.filter(p => {
                    //支付确认数量为零时的发货
                    // return p.deliveryAmount > 0 || p.preSaleOrderDetailOrderQuantityActual === 0 && p.deliveryAmount === 0;
                    return p.deliveryAmount >= 0;
                }).map(p => {
                    return {
                        preSaleOrderDetailUuid: p.preSaleOrderDetailUuid,
                        quantity: p.deliveryAmount,
                        deliveryDetailUuid: p.deliveryDetailUuid,
                        remark: p.remark
                    };
                })
            };

            if (submitData.deliveryDate === '') {
                this.$Modal.error({ title: '出错啦', content: '送货日期不能为空' });
                return;
            }

            let zeroQuanityItems = submitData.deliveryItems.filter(e => {
                return e.quantity === 0;
            });

            if (zeroQuanityItems.length > 0) {
                this.$Modal.confirm({
                    title: '存在发货数量为零的商品，确认要发货？',
                    onOk: () => {
                        this.innerSpin = true;
                        savePreSaleDistributionStationDelivery(submitData).then(res => {
                            this.innerSpin = false;
                            if (res.code === 0) {
                                this.$Modal.success({
                                    title: '保存成功',
                                    onOk: () => {
                                        this.show = false;
                                        this.$parent.init();
                                    }
                                });
                            }
                        });
                    }
                });
            }
            else {
                this.innerSpin = true;
                savePreSaleDistributionStationDelivery(submitData).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '保存成功',
                            onOk: () => {
                                this.show = false;
                                this.$parent.init();
                            }
                        });
                    }
                });
            }
        }
    }
};
</script>

<style scoped>
</style>
